import Vue from "vue";
import VueCookies from "vue-cookies";
Vue.use(VueCookies);

import Router from "vue-router";

// import Login from "@/views/Login/Login";

// import Dashboard from "@/views/Dashboard/Dashboard";
// import Home from "@/views/Dashboard/Home/Home";
// import GerirSocios from "@/views/Dashboard/Associado/GerirSocios/GerirSocios";
// import Frequencia from "@/views/Dashboard/Associado/Frequencia/Frequencia";
// import Mensalidade from "@/views/Dashboard/Associado/Mensalidade/Mensalidade";
// import ReceitasDespesas from "@/views/Dashboard/Financeiro/ReceitasDespesas/ReceitasDespesas";
// import GerirContas from "@/views/Dashboard/Financeiro/GerirContas/GerirContas";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      // component: Login,
      component: () => import('@/views/Login/Login')
    },

    // Login component
    {
      path: "/login",
      name: "Login",
      // component: Login,
      component: () => import('@/views/Login/Login')
    },

    // Dashboard component
    {
      path: "/",
      name: "Dashboard",
      // component: Dashboard,
      component: () => import('@/views/Dashboard/Dashboard'),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: "/",
          name: "Home",
          // component: Home,
          component: () => import('@/views/Dashboard/Home/Home'),
        },
        {
          path: "/gersocios",
          name: "GerirSocios",
          // component: GerirSocios,
          component: () => import('@/views/Dashboard/Associado/GerirSocios/GerirSocios'),
        },
        {
          path: "/recdesp",
          name: "ReceitasDespesas",
          // component: ReceitasDespesas,
          component: () => import('@/views/Dashboard/Financeiro/ReceitasDespesas/ReceitasDespesas'),
        },
        {
          path: "/gercontas",
          name: "GerirContas",
          // component: GerirContas,
          component: () => import('@/views/Dashboard/Financeiro/GerirContas/GerirContas'),
        },
        {
          path: "/frequencias",
          name: "Frequencia",
          // component: Frequencia,
          component: () => import('@/views/Dashboard/Associado/Frequencia/Frequencia'),
        },
        {
			path: '/mensalidades',
			name: 'Mensalidade',
      // component: Mensalidade,
      component: () => import('@/views/Dashboard/Associado/Mensalidade/Mensalidade'),
		}
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  const tokenExists = window.$cookies.isKey("USERTOKEN");
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !tokenExists) next("/login");
  else if (!requiresAuth && tokenExists) next("/");
  else next();
});

export default router;
